var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-button',{staticClass:"mb-5",attrs:{"color":"green"},on:{"click":_vm.addAdditionalField}},[_vm._v(" "+_vm._s(_vm.$t('catalogMapping.addNewField'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }